/**
 * Warning: this is a PARTIAL copy of "abcstrategie/cogaa" project's file.
 * Each update of the main project should be manually made.
 */
import utils from '../../helpers/utils'

// Initial state
const initialState = {
  token: null,
  logged: false,
  lastLogin: null,
  expirationDate: null,
  present: false,
  absent: null,
  able: true,
  username: null,
  name: null,
  lastname: null,
  role: null,
  estateIds: null,
  expirationTime: null,
  activities: []
}

// Getters
const getters = {
  fullname: (state) => {
    return state.name && state.lastname ? `${state.name} ${state.lastname}` : ''
  },
  isSuperUser: (state) => {
    return state.logged && state.role === 'superuser'
  },
  isDirector: (state) => {
    return state.logged && state.role === 'director'
  },
  isAdmin: (state) => {
    return state.logged && state.role === 'admin'
  },
  isCoordinator: (state) => {
    return state.logged && state.role === 'coordinator'
  },
  isManager: (state) => {
    return state.logged && state.role === 'manager'
  },
  isLeader: (state) => {
    return state.logged && state.role === 'leader'
  },
  isWorkman: (state) => {
    return state.logged && state.role === 'workman'
  }
}

// Actions
const actions = {
  logoutAction ({commit, state}) {
    commit('logoutMutation')
  },
  loginAction ({commit, state}, data) {
    commit('logoutMutation')
    commit('loginMutation', data)
  },
  updateTokenAction ({commit, state}, params) {
    commit('updateExpirationDateMutation', params.timestamp)
    commit('updateTokenMutation', params.token)
  },
  startDayAction ({commit, state}) {
    commit('startDayMutation')
    commit('updateCapabilityMutation', {'status': 'startday'})
  },
  endDayAction ({commit, state}) {
    commit('endDayMutation')
    commit('updateCapabilityMutation', {'status': 'endday'})
  },
  dayOffAction ({commit, state}) {
    commit('dayOffMutation')
    commit('updateCapabilityMutation', {'status': 'dayoff'})
  },
  sickAction ({commit, state}) {
    commit('sickMutation')
    commit('updateCapabilityMutation', {'status': 'sick'})
  },
  updateCapabilityAction ({commit, state}, status) {
    commit('updateCapabilityMutation', status)
  },
  updateActivitiesAction ({commit, state}, activities) {
    commit('updateActivitiesMutation', Array.isArray(activities) && activities.length ? activities : [])
  },
  updateActivityAction ({commit, state}, params) {
    commit('updateActivityStatus', params)
  }
}

// Mutations
const mutations = {
  logoutMutation (state) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  },
  updateTokenMutation (state, token) {
    state.token = token
  },
  updateExpirationDateMutation (state, timestamp) {
    state.expirationDate = timestamp + state.expirationTime
  },
  startDayMutation (state) {
    state.present = true
    state.absent = null
  },
  endDayMutation (state) {
    state.present = false
    state.absent = null
    state.able = false
  },
  dayOffMutation (state) {
    state.present = false
    state.absent = 'dayoff'
    state.able = false
  },
  sickMutation (state) {
    state.present = false
    state.absent = 'sick'
    state.able = false
  },
  updateCapabilityMutation (state, status) {
    let able = true
    if (!status || Object.keys(status).length === 0) {
      state.absent = null
      state.present = false
    } else {
      if (['startday'].indexOf(status.status) !== -1) {
        state.absent = null
        state.present = true
      }
      if (['sick', 'dayoff'].indexOf(status.status) !== -1) {
        state.absent = status.status
        state.present = false
        able = false
      }
      if (['endday'].indexOf(status.status) !== -1) {
        state.absent = null
        state.present = false
        able = false
      }
    }

    state.able = able
  },
  updateActivitiesMutation (state, activities) {
    state.activities = activities
  },
  updateActivityStatus (state, params) {
    let id = params.id || null
    let status = params.status || null

    if (id && status) {
      state.activities = state.activities.map(activity => {
        if (parseInt(activity.id) === parseInt(id)) {
          activity.status = status
        }
        return activity
      }).filter(activity => activity.status !== 'COMPLETED')
    }
  },
  loginMutation (state, data) {
    state.logged = true
    state.lastLogin = utils.now()

    state.token = data.data
    state.expirationTime = data.expiration_time
    state.expirationDate = utils.now() + data.expiration_time

    state.username = data.username
    state.name = data.name
    state.lastname = data.lastname
    state.role = data.role
    state.estateIds = data.estate_ids
    state.token = data.token
    state.present = false
    state.able = true
    state.activities = []
  }
}

export default {
  namespaced: true,
  state: utils.copy(initialState),
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js